module.exports = __webpack_public_path__ + "static/INGMeWeb-Regular-9531ef579ed5b9569b6ed482aa1f297a.woff";